<template>
  <div class="nuttrema-layout-content" :class="[`theme-${theme}`]">
    <slot name="overflow"></slot>
    <div class="nuttrema-layout-content__main">
      <div class="nuttrema-layout-content__header" :class="[headerClassName]">
        <slot name="header"></slot>
      </div>
      <div class="nuttrema-layout-content__sub_header" :class="[subHeaderClassName]">
        <slot name="sub-header"></slot>
      </div>
      <slot>
        <div class="nuttrema-layout-content__central" :class="[centralClassName]">
          <slot name="central"></slot>
        </div>
      </slot>
    </div>
    <transition name="fade">
      <div v-if="checkSlot('east-block')" class="nuttrema-layout-content__east-block">
        <slot name="east-block"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-layout-content',
  props: {
    headerClassName: {
      type: String,
      required: false,
      default: null,
    },
    subHeaderClassName: {
      type: String,
      required: false,
      default: null,
    },
    centralClassName: {
      type: String,
      required: false,
      default: null,
    },
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
  },
  methods: {
    checkSlot(slot) {
      if (this.$slots && this.$slots[slot]) {
        return this.$slots[slot][0].tag !== undefined;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/theme/colors";
@import "~styles/mixins/gradients";

  .nuttrema-layout-content {
    flex-grow: 1;
    display: flex;
    align-self: stretch;
    position: relative;

    > .east-block-wrapper {
      border-top: none;
      border-radius: 5px;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border: 1px solid $border-color;
    }

    @at-root #{&}__main {
      flex-grow: 1;
      display: flex;
      align-self: stretch;
      flex-direction: column;
    }

      @at-root #{&}__menubar {
        align-self: stretch;
      }

      @at-root #{&}__header {
        align-self: stretch;
      }

      @at-root #{&}__sub_header {
        align-self: stretch;
        background-color: rgba(#DBE2EF, 0.25);
      }

      @at-root #{&}__central {
        display: flex;
        flex-grow: 1;
        overflow: hidden;
        border-top: none;
        position: relative;
        border-radius: 0px;
        align-self: stretch;
        flex-direction: column;
        background-color: #fff;
        // background-color: $index-list-bg;
        &.is-white {
          background-color: #fff;
        }
      }

    @at-root #{&}__east-block {
      flex-basis: 20%;
      align-self: stretch;
    }

    &.theme-global {
      .nuttrema-theme-professional-turquoise & {
        .nuttrema-layout-content__central {
          background: transparent;
        }
      }
      .nuttrema-theme-professional-topography & {
        .nuttrema-layout-content__central {
          background: transparent;
        }
      }
    }

    &.theme-dark-blue {
      .nuttrema-layout-content__central {
        border-radius: 0;
        @include gradient-horizontal(#2042A3, #101C59);
        // @include gradient-horizontal(#, #101C59);
      }
    }

    &.theme-dc-logo {
      .nuttrema-layout-content__central {
        background-color: #fff;
        &:after {
          z-index: 0;
          width: 100%;
          content: '';
          height: 100%;
          opacity: 0.1;
          top: 0; left: 0;
          position: absolute;
          background-size: 48em;
          background-repeat: no-repeat;
          background-position: right -8em bottom -8em;
          background-image: url('~assets/images/dc-logo-bg.svg');
        }
      }
    }

    &.theme-cred-layout {
      margin: 0.5em 0.75em;
      transition: all 0.10s;
      border-radius: 0.5em;
      background-color: #fff;
      border: 2px solid #DBE2EF;
      .nuttrema-layout-content__central {
        border-top-left-radius: 0.5em;
        border-top-right-radius: 0.5em;
      }
    }

    &.theme-turquoise {
      .nuttrema-layout-content__central {
        border-radius: 0;
        @include gradient-horizontal($turquoise, darken($turquoise, 5%));
      }
    }

    &.theme-topography {}

    &.is-have-margin {
      .nuttrema-layout-content__central {
        padding: 1.5em 2em;
      }
    }

    &.is-central-scroll {
      .nuttrema-layout-content__central {
        overflow-y: auto;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/layout/nuttrema-layout-content.vue